import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface UiState {
  debug: boolean;
  setDebug: (debug: boolean) => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      debug: false,
      setDebug: (debug) => set({ debug }),
    }),
    {
      name: "sd-ui",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
